<div fxLayout="row" fxLayoutAlign="center">
	<div
		fxLayout="column"
		class="dark-grey-texts"
		fxFlex.gt-xs="100%"
		fxFlex.xs="90%"
		ngClass="p-b-xxl m-b-xl"
	>
		<div
			fxLayout.gt-xs="row"
			fxLayout.xs="column"
			fxFlex="100%"
			fxLayoutAlign="center"
			fxLayoutGap="3%"
		>
			<div fxLayout="column" fxFlex.gt-sm="35%" fxFlex.sm="40%">
				<img
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/multiTeamFundraiser/public"
				/>
			</div>
			<div
				fxLayout="column"
				fxFlex.sm="45%"
				fxFlex.md="40%"
				fxFlex.lg="28%"
				fxFlex.gt-lg="39%"
				fxLayoutAlign="center"
			>
				<div fxLayout="row">
					<mat-card-title
						class="inc-largetext-height"
						i18n="@@org_multi_team_fundraising_heading"
						>Multi-Team fundraising</mat-card-title
					>
				</div>
				<div fxLayout="row">
					<p
						class="inc-span-height"
						i18n="@@org_multi_team_fundraising_content"
					>
						Setup your own donation-based crowdfunding or fundraising website.
						Choose a simple Crowdfunding setup, have other people create a
						peer-to-peer fundraiser , or create multi-team fundraising
						campaigns.
					</p>
				</div>
				<div fxLayout="row" fxLayoutAlign="flex-start center" ngClass="p-t-m">
					<a mat-button color="accent" (click)="languageForWhydonatePlatform()">
						<span class="mat-headline-6" i18n="@@button_learnMore"
							>Learn More</span
						></a
					>
				</div>
			</div>
		</div>
	</div>
</div>
